import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {GlobalModule} from "../global/global.module";
import {FinalDokumenRoutingModule} from "./final-dokumen-routing.module";
import {FinalDokumenComponent} from "./final-dokumen.component";



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    FinalDokumenRoutingModule,
    GlobalModule
  ],
  declarations: [
    FinalDokumenComponent
  ]
})
export class FinalDokumenModule { }
